export const remove =
  'M211.37,236,236,211.37,44.63,20,20,44.63ZM20,211.37,44.63,236,236,44.63,211.37,20Z'
